import {
  EditableInput,
  RequiredAsterisk,
} from "@smart/itops-sb-design-system-dom";

import { FieldComponentType, fieldFallbackLabel, FieldItem } from "../../types";

export type LabelProps = Pick<
  FieldItem,
  "uri" | "label" | "hint" | "description" | "mandatory" | "layout"
> & {
  index?: number;
  hideLabel?: boolean;
  fontWeight?: "bold" | "semibold" | "normal";
  fontSize?: "ui" | "paragraph";
  type: FieldComponentType;
};

export const Label = ({
  label,
  description,
  mandatory,
  type,
  hideLabel,
  fontWeight,
  fontSize,
}: Omit<LabelProps, "uri" | "index">) => {
  const fallback = fieldFallbackLabel[type as FieldComponentType];

  return (
    <div className="flex flex-col gap-small">
      {!hideLabel && (
        <div className="flex items-center">
          <EditableInput
            className="py-0"
            text={label || fallback}
            fontSize={fontSize || "ui"}
            fontWeight={fontWeight || "semibold"}
            isPreview
            disabled
          />
          {mandatory && <RequiredAsterisk />}
        </div>
      )}
      {description && type !== "info" && (
        <div className="text-neutral-700">
          <EditableInput
            className="py-0"
            text={description}
            fontSize="caption"
            dataTestId="description"
            isPreview
            disabled
          />
        </div>
      )}
    </div>
  );
};
